<template>
  <div class="mypage-point-item-parts">
    <div class="mypage-point-item-parts__body">
      <p class="mypage-point-item-parts__point">
        <span class="mypage-point-item-parts__point__icon">
          <mypage-point-minus-icon v-if="item.status === 'lost'" />
          <mypage-point-plus-icon v-if="item.status === 'get'" />
        </span>
        <span class="mypage-point-item-parts__point__data">{{ item.point }}</span>
        <span class="mypage-point-item-parts__point__unit">p</span>
      </p>
      <p v-if="item.description !== ''" class="mypage-point-item-parts__description">
        {{ item.description }}
      </p>
    </div>
    <p class="mypage-point-item-parts__date">{{ item.date }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import MypagePointMinusIcon from '@/components/MypagePointHistoryPage/MypagePointHistoryPane/parts/icons/MypagePointMinusIcon.vue'
import MypagePointPlusIcon from '@/components/MypagePointHistoryPage/MypagePointHistoryPane/parts/icons/MypagePointPlusIcon.vue'

export default defineComponent({
  name: 'MypagePointItemParts',
  components: { MypagePointPlusIcon, MypagePointMinusIcon },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
})
</script>

<style scoped lang="scss">
.mypage-point-item-parts {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  padding-top: 12px;
  padding-bottom: 12px;

  &__point {
    display: flex;
    align-items: center;

    &__icon {
      display: flex;
      flex-shrink: 0;
      align-items: center;
      justify-content: center;
      width: 8px;
      height: 8px;
      margin-right: 2px;
    }

    &__data {
      position: relative;
      font-size: 13px;
      font-weight: 500;
      line-height: 1.53;
    }

    &__unit {
      font-size: 10px;
      font-weight: 500;
      line-height: 1.2;
    }
  }

  &__description {
    padding-left: 10px;
    font-size: 10px;
    font-weight: 500;
    color: $gray75;
    line-height: 1.4;
    letter-spacing: 0.04em;
  }

  &__date {
    font-size: 11px;
    font-weight: 500;
    color: $gray75;
    letter-spacing: 0.04em;
  }
}
</style>
